import api from './api';

export interface Torrefacao {
  id: string;
  name: string;
  description: string;
  address: string;
  cityId: string;
  cityName: string;
  stateId: string;
  stateName: string;
  instagram: string;
  logoUrl: string;
  coverImageUrl: string;
  cnpj: string;
  phone: string;
  email: string;
  website: string;
  type: number;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface TorrefacoesResponse {
  places: Torrefacao[];
  pagination: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

export interface CreateTorrefacaoRequest {
  name: string;
  description: string;
  address: string;
  cityId: string;
  instagram: string;
  logoUrl: string;
  coverImageUrl: string;
  cnpj?: string;
  phone?: string;
  email?: string;
  website?: string;
}

export interface UpdateTorrefacaoRequest {
  name: string;
  description: string;
  address: string;
  instagram: string;
  logoUrl: string;
  coverImageUrl: string;
  cnpj?: string;
  phone?: string;
  email?: string;
  website?: string;
}

export const torrefacoesService = {
  // Listar torrefações (places com type = 2)
  getTorrefacoes: async (params?: {
    page?: number;
    pageSize?: number;
    search?: string;
    status?: string;
  }): Promise<TorrefacoesResponse> => {
    const response = await api.get('/admin/places', {
      params: {
        ...params,
        type: 2, // Filtrar apenas torrefações
      }
    });
    return response.data;
  },

  // Buscar torrefação por ID
  getTorrefacaoById: async (id: string): Promise<Torrefacao> => {
    const response = await api.get(`/admin/places/${id}`);
    return response.data;
  },

  // Criar torrefação
  createTorrefacao: async (data: CreateTorrefacaoRequest): Promise<Torrefacao> => {
    const response = await api.post('/admin/places', {
      ...data,
      type: 2, // Sempre criar como torrefação
    });
    return response.data;
  },

  // Atualizar torrefação
  updateTorrefacao: async (id: string, data: UpdateTorrefacaoRequest): Promise<Torrefacao> => {
    const response = await api.put(`/admin/places/${id}`, {
      ...data,
      type: 2, // Manter como torrefação
    });
    return response.data;
  },

  // Deletar torrefação
  deleteTorrefacao: async (id: string): Promise<void> => {
    await api.delete(`/admin/places/${id}`);
  },

  // Buscar estatísticas das torrefações
  getTorrefacoesStats: async () => {
    const response = await api.get('/admin/places/stats', {
      params: { type: 2 }
    });
    return response.data;
  },
};
